import { Button } from "@/components/ui/button";
import { useTranslations } from "use-intl";
import { useEffect, useState } from "react";
import { X } from "lucide-react";

const COOKIE_CONSENT_KEY = "cookie-consent";

export default function CookieConsent() {
  const [open, setOpen] = useState(false);
  const t = useTranslations("cookie_consent");

  useEffect(() => {
    const hasConsent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!hasConsent) {
      setOpen(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "true");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50">
      <div className="mx-auto max-w-7xl px-4 py-3 sm:px-6 lg:px-8">
        <div className="flex flex-wrap items-center justify-between gap-x-6 gap-y-3 rounded-lg bg-background/95 p-4 shadow-lg ring-1 ring-gray-900/10 backdrop-blur">
          <div className="flex flex-1 items-center gap-x-4">
            <div className="flex-1">
              <h2 className="text-sm font-semibold leading-6 text-foreground">
                {t("title")}
              </h2>
              <p className="mt-1 text-sm leading-5 text-muted-foreground">
                {t("description_before")}{" "}
                <a
                  href="/cookies"
                  className="text-primary hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                >
                  {t("policy_text")}
                </a>
                {t("description_after")}
              </p>
            </div>
          </div>
          <div className="flex flex-none items-center gap-x-4">
            <Button
              onClick={handleAccept}
              className="flex-none rounded-full bg-primary px-3.5 py-2 text-sm font-semibold text-primary-foreground shadow-sm hover:bg-primary/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
            >
              {t("accept")}
            </Button>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="flex-none rounded-full p-1.5 text-muted-foreground hover:bg-muted"
            >
              <span className="sr-only">Dismiss</span>
              <X className="h-5 w-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
